import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Badge, Row, Col, Card, Button, Dropdown } from 'react-bootstrap';
import CsLineIcons from "../../../../../cs-line-icons";
import { toDate, addDays } from "../../../../../utils/date";
import { deepEqual } from "../../../../../utils/object";
import ConditionalLink from "../../../../../layout/conditional-link";

export function supports(query) {
    return query === "card"
}

class Credit extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.propsToState(this.props);
    }

    propsToState = (props) => {
        const expanded = JSON.parse(props.meta);
        const expiresDate = new Date(props.expiresDate);
        const now = Date.now();
        const expired = expiresDate < now;
        const compareDate = new Date(addDays(now, 60));
        const expiresSoon = !expired && (expiresDate < compareDate);

        return {
            uuid: props.uuid,
            brand: expanded.brand,
            last4: props.last4,
            expiresDate,
            primary: props.order === 1,
            secondary: props.order === 2,
            unordered: props.order === 0,
            address: props.address || props.Address,
            order: props.order,
            name: props.name || "",
            expired,
            expiresSoon
        }
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props, oldProps)) {
            this.setState({
                ...this.state,
                ...this.propsToState(this.props)
            });
        }
    }

    onPrimary = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("order", { ...this.state, order: 1, primary: true, secondary: false, unordered: false });
    }

    onSecondary = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("order", { ...this.state, order: 2, primary: false, secondary: true, unordered: false });
    }

    onDelete = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("delete", { ...this.state });
    }

    onDoubleClick = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("doubleClick", { ...this.state });
    }

    onClick = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("click", { ...this.state });
    }
    
    onEdit = (e) => {
        e.preventDefault();
        if (this.props.on) this.props.on("edit", { ...this.state });
    }

    get title() {
        return `${this.state.brand} x-${this.state.last4}`;
    }

    

    render() {
        return <>
            <Col md="4" sm="6" lg="4" xl="3" xxl="2" xs="12">
                <Card className="mb-5 border border-muted rounded-lg" role="button" style={{ minHeight: "200px" }} onDoubleClick={this.onDoubleClick} onClick={this.onClick}>
                    <Card.Body>
                        <Row>
                            <Col xs="3">
                                <CsLineIcons icon="credit-card" height="40" width="40"></CsLineIcons>
                            </Col>
                            <Col xs="7">
                                <Card.Title style={{ marginTop: "10px" }}>{this.title}</Card.Title>
                            </Col>
                            <Col xs="2">
                                {(!this.state.primary) ? (
                                <Dropdown align="end" as="div" style={{ position: 'initial' }}>
                                    <Dropdown.Toggle
                                        as={this.toggleButton}
                                        variant="foreground"
                                        className="hover-outline btn-icon btn-icon-only btn-sm position-absolute e-0 t-0 me-card mt-card z-index-1"
                                    />
                                    
                                        <Dropdown.Menu className="task-buttons">
                                            <ConditionalLink className="dropdown-item" href="#" onClick={this.onPrimary} caption="Make Primary" display={!this.state.primary && !this.state.expired}></ConditionalLink>
                                            <ConditionalLink className="dropdown-item" href="#" onClick={this.onSecondary} caption="Make Secondary" display={this.state.unordered && !this.state.expired}></ConditionalLink>
                                            <ConditionalLink className="dropdown-item" href="#" onClick={this.onDelete} caption="Delete" display={!this.state.primary}></ConditionalLink>
                                        </Dropdown.Menu>
                                    
                                </Dropdown>
                                ) : ``}
                            </Col>
                        </Row>
                        <Card.Text>Expires: {toDate(this.props.expiresDate).toLocaleDateString("en-us", { month: "short", year: "numeric" })}</Card.Text>
                        <Card.Text>
                            {(this.state.primary) ? (
                                <span
                                    role="button"
                                    className="badge rounded-pill bg-primary"
                                    style={{ marginLeft: "5px", paddingLeft: "15px", paddingRight: "15px" }}>Primary</span>
                            ) : ``}
                            {(this.state.secondary) ? (
                                <span
                                    role="button"
                                    className="badge rounded-pill bg-secondary"
                                    style={{ marginLeft: "5px", paddingLeft: "15px", paddingRight: "15px" }}>Secondary</span>
                            ) : ``}
                            {(this.state.expired) ? (
                                <span
                                    role="button"
                                    className="badge rounded-pill bg-danger"
                                    style={{ marginLeft: "5px", paddingLeft: "15px", paddingRight: "15px" }}>Expired</span>
                            ) : ``}
                            {(this.state.expiresSoon) ? (
                                <span
                                    role="button"
                                    className="badge rounded-pill bg-warning"
                                    style={{ marginLeft: "5px", paddingLeft: "15px", paddingRight: "15px" }}>Expiring Soon</span>
                            ) : ``}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </>
    }
}
    
Credit.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(Credit);